<template>
  <div class="upload-screen-1-container">

    <!--h3>Step 5/5</h3>

    <img v-lazy="uploadedImgUrl" height="100" width="100"> <br>

   <!-- {{$route.query}} <br><br>

    <!-- KEYWORDS -->
    <!-- keywords => {{$store.state.uploadImage_5.selectedKeywords_uploadImage}}
    <v-select
      v-model="$store.state.uploadImage_5.selectedKeywords_uploadImage"
      label="Keywords"
      chips
      tags
      :items="$store.state.uploadImage_5.keywords_uploadImage"
      :search-input.sync="$store.state.uploadImage_2.qStr_tags_uploadImage"
      @keyup="$store.state.uploadImage_2.qStr_searchThisTag = 'keywords'"
    ></v-select>

    google vision api label suggestions => {{googleCloudVisionAPI_labelSuggestion}} <br>
    <div>
      <span v-for="(tag, key) in imaggaSuggestion" v-if="key < 10">
        <button class="suggestion-btn" v-if="selectedKeywords_uploadImage.indexOf(tag) == -1"  @click="selectThisImaggaSuggestion({
          tag
        })">
          {{tag}}
        </button>
        <button class="suggestion-btn"  v-else @click="deselectThisImaggaSuggestion({
          tag
        })">
          {{tag}}
        </button>
      </span>
    </div-->

    <!-- LOCATION VISIBLE>
    selected location visible tags => {{$store.state.uploadImage_2.selectedLocationVisible_uploadImage}} <br>
    <!--v-select
      v-model="$store.state.uploadImage_2.selectedLocationVisible_uploadImage"
      label="Location visible in this photo"
      chips
      tags
      :items="$store.state.uploadImage_2.locationVisible_uploadImage"
      :search-input.sync="$store.state.uploadImage_2.qStr_tags_uploadImage"
      @keyup="$store.state.uploadImage_2.qStr_searchThisTag = 'locationVisible'"
    ></v-select> <br>

    <loader v-if="imageUploadingToStorage"></loader>
    <div v-else>
      <span v-for="(tag, key) in googleCloudVisionAPI_landmarkSuggestion">
        <v-chip v-if="selectedLocationVisible_uploadImage.indexOf(tag) == -1" outline @click="selectThisGoogleVisionAPI_landmark({
          tag
        })">
          {{tag}}
        </v-chip>
        <v-chip v-else @click="deselectThisGoogleVisionAPI_landmark({
          tag
        })">
          {{tag}}
        </v-chip>
      </span>
    </div>

    <button
      @click="sharePhoto_uploadImage_5({
         url: $route.query.url,
         resourceType: $route.query.resourceType,
         publicId: $route.query.publicId,
         //
         createdAt: $route.query.createdAt,
         //
         caption: $route.query.caption,
         locationVisible: $store.state.uploadImage_2.selectedLocationVisible_uploadImage, // now shifted to this page, instead of being in query
         emotionalAppeal: JSON.parse($route.query.emotionalAppeal),
         //
         shareSpotLocation: JSON.parse($route.query.shareSpotLocation), //parsed
         hasGeohash: $route.query.hasGeohash,
         //
         spotType: JSON.parse($route.query.spotType),
         anyoneCanVisitThisSpot: $route.query.anyoneCanVisitThisSpot,
         //
         keywords: $store.state.uploadImage_5.selectedKeywords_uploadImage
      })"
    >
      share
    </button-->









    <!-- ******************* NEW UI ************************* -->


    <div class="white upload-screen-1-container">
    <div class="pa-3">
      <div class="important-details-container">
        <!--div-- class="back-icon text-xs-left">
          <v-icon>keyboard_backspace</v-icon>
        </div-->
        <div class="important-details">Make it popular</div>
      </div>
      <div style="display: flex; align-items: center">
        <v-icon class="grey--text" @click="$router.go(-1)">keyboard_backspace</v-icon>
        <div class="grey" style="width: 100%; height: 1px"></div>
      </div>

      <v-layout row wrap class="img-and-caption-container">
        <v-flex xs4 md1 class="img-container">
          <img v-lazy="uploadedImgUrl"/>
        </v-flex>
        <v-flex xs8 md11 class="caption-container">
          The more relevant tags you add to this photo, the more people will discover it.
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-between class="tags-container">
        <v-flex class="tag-headline text-xs-left">
          Tags: Selected
        </v-flex>
        <v-flex class="tag-btn-container text-xs-right">
          <v-btn
            class="cyan white--text"
            round small style="margin: 0;
            font-size: 11px"
            @click="openAddTagDialog = true"
          >
            Add new
          </v-btn>
        </v-flex>
      </v-layout>

      <div class="tags-chip-container text-xs-left" style="display: flex; flex-wrap: wrap">
        <div  style="position: relative;" v-for="(chip,chipIndex) in $store.state.uploadImage_5.selectedKeywords_uploadImage" :key="chipIndex" class="text-xl-left">
          <v-icon
            @click="$store.state.uploadImage_5.selectedKeywords_uploadImage.splice(chipIndex, 1)"
            style="position: absolute; top: 7px; right: 13px; font-size: 18px; z-index: 3; cursor: pointer;"
          >
            clear
          </v-icon>
          <v-chip
            style="padding: 0 2vh 0 0; font-size: 12px"
            outline
            label
            class="blue black--text"
            small
          >
            {{chip}}
          </v-chip>
        </div>
      </div>


      <v-layout row wrap justify-space-between class="tags-container mt-3">
        <v-flex class="tag-headline text-xs-left">
          Suggested
        </v-flex>
      </v-layout>


      <div class="text-xs-left">
        <button
          v-for="(tag, key) in imaggaSuggestion"
          v-show="key < 10"
          class="suggestion-btn "
          v-if="
          $store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1"
          @click="selectThisImaggaSuggestion({
          tag
        })">
          {{tag}}
        </button>
        <button class="suggestion-btn"  v-show="
          $store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1" v-else @click="deselectThisImaggaSuggestion({
          tag
        })">
          {{tag}}
        </button>
      </div>

      <!--div-- class="text-xs-left">
        <button
          @click="selectedTags.push(suggestionText)"
          v-for="suggestionText in suggestions"
          class="suggestion-btn"
        >
          {{suggestionText}}
        </button>
      </div-->
      <div class="text-xs-right" >
        <v-btn
          :disabled="$store.state.uploadImage_5.showShareButton"
          outline
          small
          class="primary primary--text"
          @click="sharePhoto_uploadImage_5({
         url: $route.query.url,
         resourceType: $route.query.resourceType,
         publicId: $route.query.publicId,
         //
         createdAt: $route.query.createdAt,
         //
         caption: $route.query.caption,
         locationVisible: $store.state.uploadImage_2.selectedLocationVisible_uploadImage, // now shifted to this page, instead of being in query
         emotionalAppeal: JSON.parse($route.query.emotionalAppeal),
         //
         shareSpotLocation: JSON.parse($route.query.shareSpotLocation), //parsed
         hasGeohash: $route.query.geoLocIsAvailable,
         //
         spotType: JSON.parse($route.query.spotType),
         anyoneCanVisitThisSpot: $route.query.anyoneCanVisitThisSpot,
         //
         keywords: $store.state.uploadImage_5.selectedKeywords_uploadImage,
         travelInfo: $route.query.pic_desc,
          _dur2: $route.query._dur2,
        _mon2: $route.query._mon2
      })"
        >
          share
        </v-btn>
      </div>


    </div>
    </div>


    <v-dialog v-model="openAddTagDialog" width="300">
      <v-card class="pa-4">
        <h3 class="text-xs-center">Add new tag!</h3>



          <v-text-field
            @keyup.enter="
            newTag.length > 0 ? $store.state.uploadImage_5.selectedKeywords_uploadImage.push(newTag): '';
            newTag='';
            openAddTagDialog = false"
            ref="addTag"
            label="Type image tag name"
            v-model="newTag"
          >
          </v-text-field>





        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn

            small
            outline
            class="primary primary--text"
            @click="
            newTag.length > 0 ? $store.state.uploadImage_5.selectedKeywords_uploadImage.push(newTag): '';
            newTag='';
            openAddTagDialog = false
            "
          >
            add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- ******************* /NEW UI ************************* -->

  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import {mapGetters} from 'vuex'
  //
  import uploadImage from '../../mixin/uploadImage'
  import loader from '@/components/loaders/fullscreenLoader'
  //
  let vm
  //
  export default {
    data () {
      return {
        openAddTagDialog: false,
        newTag: ''
      }
    },
    //
    mixins: [
      uploadImage
    ],

    methods:{
      ...mapMutations([
        'sharePhoto_uploadImage_5','selectThisImaggaSuggestion','deselectThisImaggaSuggestion',
        'selectThisGoogleVisionAPI_landmark', 'deselectThisGoogleVisionAPI_landmark'
      ])
    },
    computed:{
      ...mapGetters([
        'imaggaSuggestion','selectedKeywords_uploadImage',
        'googleCloudVisionAPI_landmarkSuggestion', 'googleCloudVisionAPI_labelSuggestion',
        'imageUploadingToStorage','selectedLocationVisible_uploadImage'
      ])
    },
    created(){
      window.thisOfVueComp = this
      vm = this
      this.$store.commit('getGoogleVisionAPISuggestionFromLocalStorage') //contain both imagga & vision api query from ls
    },
    mounted () {
      // this.$refs.addTag.focus()
    },
    components:{
      loader
    },
    watch: {
      openAddTagDialog: () => {
        if(window.thisOfVueComp.openAddTagDialog) {
          vm.$refs.addTag.focus()
        }
        else {
          vm.$refs.addTag.blur()
        }
      }
    }
    //
  }
</script>
<style lang="scss" scoped>
  .upload-screen-1-container {
    height: 100vh;
    width: 100%;
    .hr-text {
      line-height: 1em;
      position: relative;
      outline: 0;
      border: 0;
      color: black;
      text-align: center;
      height: 1.5em;
      opacity: .5;
      &:before {
        content: '';
        background: #818078;
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 1px;
      }
      &:after {
        -webkit-font-feature-settings: 'liga';
        position: relative;
        margin-left: -100%;
        margin-top: -6px;
        font-size: 24px;
        display: inline-block;
        font-family: 'Material Icons';
        content: "keyboard_backspace";
        -webkit-font-feature-settings: 'liga' 1;
        -moz-font-feature-settings: 'liga' 1;
        font-feature-settings: 'liga' 1;

        padding: 0 .5em;
        line-height: 1.5em;
        // this is really the only tricky part, you need to specify the background color of the container element...
        color: #818078;
        background-color: #fcfcfa;
      }
    }
    .suggestion-btn {
      margin: 5px 5px;
      padding: 5px 20px;
      border: 1px solid lightgrey;
      border-radius: 10px;
      outline: none;
      font-size: 0.714em;
    }
    .tags-container {
      .tag-headline {
        font-size: 1.286em;
        font-weight: 700;
      }
      .tag-btn {

      }
    }
    .important-details-container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      position: relative;

      .back-icon {
        position: absolute;
        left: 0;
        top: 58%
      }
      .important-details {
        width: 98%;
        text-align: right;
        font-size: 1.286em;
        font-weight: 700;
      }
      .hr-div {
        margin-left: 20px ;
        position: absolute;
        width: 90%;
        top: 58%;
        left: 20px;
        background: lightgrey;
        height: 1px;
      }
    }
    .img-and-caption-container {
      border-bottom: 1px solid lightgrey;
      margin: 19px 0 9px 0;
      .img-container {
        img {
          width: 6.429em;
          height: 4.286em;
          object-fit: contain;
        }
      }
      .caption-container {
        padding-left: 10px;
        text-align: left;
        .caption-text-area {
          width: 100%;
          height: 100%;
          outline: none;
          resize: none;
          ::placeholder {
            font-size: 1em;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// uploadImage_5.vue?0f782b11